export var version = '3.4.8';
//# sourceMappingURL=version.js.map